import axios from 'axios';

import getConfig from '@config';
import { applyJwtInterceptor } from '@webapp-next/lib/request/utils/jwt';
// import getInstallationUUID from '@/lib/get-installation-uuid'; // TODO apply installation id automatically
const { SVC_COMPLIANCE_JWT_ID, SVC_COMPLIANCE_BASE_URL } = getConfig();

const baseURL =
  SVC_COMPLIANCE_BASE_URL === undefined
    ? `${window.__APP__.API_COMPLIANCE_BASE_URL}/v1`
    : SVC_COMPLIANCE_BASE_URL;

const aud = SVC_COMPLIANCE_JWT_ID;
const httpClientInstance = axios.create({
  baseURL,
  crossdomain: true,
});

// TODO apply installation id automatically
// http.interceptors.request.use(function(config) {
//   const baseURL =
//     SVC_HIRE_BASE_URL ||
//     `https://${
//       window.__APP__.API_REGION_HOSTNAME
//     }/hire/v1/tenants/${getInstallationUUID()}`;
//
//   config.url = `${baseURL}${config.url}`;
//
//   return config;
// });

applyJwtInterceptor(httpClientInstance, {
  aud,
  claims: {
    deputy_user_id: '',
    deputy_business_id: '',
    deputy_employee_profile_id: '',
    deputy_business_user_id: '',
    deputy_business_location_id: '',
  },
});

export default httpClientInstance;
